/**
 * Shared post-auth redirect allow-list.
 * Relative paths only, never trust open redirects.
 */
const VALID_REDIRECT_PATHS = [
  '/',
  '/app',
  '/talk',
  '/dashboard',
  '/find-hospitals',
  '/rare-cancers',
  '/second-opinion',
  '/teleconsultation',
  '/cost-calculator',
  '/find-oncologists',
  '/get-started',
  '/oncoagent',
  '/subscribe',
  '/platform',
  '/profile',
];

export function getValidRedirectPath(redirectParam) {
  if (!redirectParam) return null;
  try {
    const decoded = decodeURIComponent(redirectParam);
    if (decoded.startsWith('http://') || decoded.startsWith('https://')) return null;
    if (decoded.startsWith('//')) return null;
    const path = decoded.split('?')[0];
    if (VALID_REDIRECT_PATHS.includes(path)) return decoded;
    if (path.startsWith('/app/') || path.startsWith('/talk') || path.startsWith('/oncoagent/app')) return decoded;
    if (VALID_REDIRECT_PATHS.some((valid) => path === valid || decoded.startsWith(`${valid}?`))) {
      return decoded;
    }
    if (VALID_REDIRECT_PATHS.some((valid) => valid !== '/' && decoded.startsWith(valid))) {
      return decoded;
    }
    return null;
  } catch {
    return null;
  }
}
